<template>
  <div class="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
    <a href="/" class="mb-8"><img src="/images/logo_testo.png" alt="StreetStock Logo" class="h-12" /></a>
    <h1 class="text-2xl font-bold mb-3">Tutto pronto 🎉</h1>
    <p class="opacity-80 mb-6">Grazie! Sei entrato nella community StreetStock Market.</p>
    <a href="/" class="btn py-3 px-6 rounded-xl font-semibold">Torna alla home</a>
  </div>
</template>

<script>
export default { name:'Done' }
</script>

<style scoped>
.btn { background:#3aa7df; color:#fff; text-decoration:none; }
.btn:hover { background:#2f93c6; }
</style>
